<template>
  <div>
    <div class="settings-top-bar sticky-header">
      <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="id" @click.prevent="handleDelete">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="button" class="btn btn-info btn-icon"
            @click="copyProduct"
            style="text-transform: capitalize"
          >
            <img src="/static/img/icons/duplicate.png" />
            {{$t('gestiune.copyProduct')}}
          </button>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save"  @click="saveProduct" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>
    <div class="row mar-to-15 mar-bt-15" style="display: flex; justify-content: flex-start; align-items: stretch; margin-top: 40px;">
      <div class="col-lg-12 col-md-12">
        <div v-if="is_external == 1" class="info-text info-text--bold">
          {{ $t('gestiune.umTaptastyInfo') }}
        </div>
        <div class="card">
            <div class="card-content">
              <div class="row mt-3">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('gestiune.productName') }}*</label>
                      <input type="text" :disabled="is_external == 1" :placeholder="$t('gestiune.productName')" v-model="productName" v-validate="modelValidate.productName" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('gestiune.productDescription') }}*</label>
                      <input type="text" :disabled="is_external == 1" :placeholder="$t('gestiune.productDescription')" v-model="productDescription" v-validate="modelValidate.productDescription" class="form-control"/>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('gestiune.gestiune') }}*</label>
                      <select
                        v-model="productType"
                        v-validate="modelValidate.productType"
                        class="form-control"
                      >
                        <option value="" disabled>Selectează opțiunea</option>
                        <option
                          v-for="(type, index) in filteredProductTypes"
                          :key="index"
                          :value="type.value"
                        >
                          {{ type.label }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <!-- Dacă produsul este de tip rețetă -->
                    <template v-if="isRecipeProduct">
                      <div class="d-flex" style="gap: 10px;">
                        <!-- Form-group pentru UM -->
                        <div class="form-group" style="flex: 0 0 150px;">
                          <label>{{ $t('gestiune.um') }} *</label>
                          <select
                            v-model="um"
                            class="form-control"
                            v-validate="modelValidate.um"
                            :disabled="is_external == 1"
                          >
                            <template v-for="unit in mesurementsUnits">
                              <option :key="unit.short" :value="unit.short">{{ unit.short }}</option>
                            </template>
                          </select>
                        </div>

                        <!-- Form-group pentru Cantitate rezultată -->
                        <div class="form-group" style="flex: 1;">
                          <label>Cantitate rezultată</label>
                          <input
                            type="number"
                            v-model="cantitateRezultata"
                            class="form-control form-control-sm"
                            placeholder="Cantitate rezultată"
                            style="width: 100%;"
                          />
                        </div>
                      </div>
                    </template>

                    <!-- Dacă NU este produs de tip rețetă -->
                    <template v-else>
                      <div class="form-group">
                        <label>{{ $t('gestiune.um') }} *</label>
                        <select
                          v-model="um"
                          class="form-control"
                          v-validate="modelValidate.um"
                          :disabled="is_external == 1"
                        >
                          <template v-for="unit in mesurementsUnits">
                            <option :key="unit.short" :value="unit.short">{{ unit.short }}</option>
                          </template>
                        </select>
                      </div>
                    </template>
                  </div>
                  <!-- <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('gestiune.price') }}</label>
                      <input type="text" :placeholder="$t('gestiune.price')" v-model="price" class="form-control"/>
                    </div>
                  </div> -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('gestiune.tva') }} *</label>
                      <select v-model="cotaTva" class="form-control" :disabled="is_external == 1">
                        <option disabled value="">Selectează TVA</option>

                        <!-- Dacă produsul e extern afișăm doar TVA-ul său -->
                        <option
                          v-if="is_external == 1 && product"
                          :value="product.vat_percent"
                        >
                          {{ product.vat_percent }} %
                        </option>

                        <!-- Dacă produsul nu e extern, afișăm toate TVA-urile din vats -->
                        <template v-else>
                          <option
                            v-for="vat in vats"
                            :key="vat.tax_id"
                            :value="vat.amount"
                          >
                            {{ vat.amount }} %
                          </option>
                        </template>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('gestiune.currency') }}</label>
                      <select v-model="currency" class="form-control" :disabled="is_external == 1">
                          <option value="RON">RON</option>
                          <option value="EUR">EURO</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('gestiune.codeProduct') }}</label>
                      <input type="text" :placeholder="$t('gestiune.codeProduct')" v-model="codeProduct" class="form-control" disabled/>
                    </div>
                  </div>
                  <!-- <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('gestiune.activeProducts') }}</label>
                      <select v-model="activeProduct" class="form-control">
                        <option :value="true">Da</option>
                        <option :value="false">Nu</option>
                      </select>
                    </div>
                  </div> -->
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{ $t('gestiune.termenValabilitate') }}</label>
                      <div class="d-flex">
                        <input
                          type="number"
                          min="0"
                          v-model.number="validityValue"
                          class="form-control"
                          placeholder="Valoare"
                          style="margin-right: 10px;"
                        />
                        <select v-model="validityUnit" class="form-control">
                          <option value="zile">Zile</option>
                          <option value="saptamani">Săptămâni</option>
                          <option value="luni">Luni</option>
                          <option value="ani">Ani</option>
                          <option value="ore">Ore</option>
                          <option value="minute">Minute</option>
                        </select>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
        </div>
      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <h5>VAT Number: <strong>{{ route.params.vatNumber }}</strong></h5>
        <!-- Info text cu VAT global -->
        <div class="info-text" style="margin-bottom: 20px;">
          Completează prețul pentru fiecare gestiune corespunzător.<br/>
        </div>

        <div class="row mt-4">
          <div
            class="col-md-4 mb-4"
            v-for="(gestiune, index) in filteredGestiuni"
            :key="gestiune._id"
          >
            <div class="card-price">
              <!-- Nume gestiune -->
               <div class="mb-1">
                <h6 style="margin: 0; font-weight: bold;">
                  {{ gestiune.name }}
                </h6>

                <!-- Locația -->
                <small style="color: #7C8DB5;">
                  Locație: <strong>{{ getLocationName(gestiune.externalLocationId) }}</strong>
                </small>
              </div>

              <!-- Input preț -->
              <div class="form-group mt-2">
                <label style="font-weight: 500;">Preț:</label>
                <input
                  type="number"
                  v-model="gestiunePrices[gestiune._id]"
                  class="form-control"
                  placeholder="Introduceți prețul"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isRecipeProduct" class="card mar-to-15">
      <div class="card-content">
        <div class="col-md-12 d-flex align-items-center" style="gap:10px; margin-bottom: 20px;">
          <p style="margin-bottom: 0px;">{{ $t('gestiune.addReteta') }}</p>
        </div>
        <hr class="sm">

        <el-table ref="recipeTable" :data="tableData" style="width: 100%" :row-class-name="tableRowClassName">
          <el-table-column :label="$t('gestiune.productName')" prop="productNameRecipe">
            <template slot-scope="scope">
              {{ scope.row.productNameRecipe }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('gestiune.gestiune')" prop="productTypeRecipe">
            <template slot-scope="scope">
              {{ scope.row.productTypeRecipe }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('gestiune.codeProduct')" prop="codeProductRecipe">
            <template slot-scope="scope">
              {{ scope.row.codeProductRecipe }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('gestiune.um')" prop="umRecipe">
            <template slot-scope="scope">
              {{ scope.row.umRecipe }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('gestiune.cantitate')" prop="quantityRecipe">
            <template slot-scope="scope">
              {{ scope.row.quantityRecipe }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('gestiune.scazamant')" prop="scazamantValue">
            <template slot-scope="scope">
              {{ scope.row.scazamantValue}} - {{ scope.row.scazamantType }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('general.actions')" width="150">
            <template slot-scope="scope">
              <el-dropdown trigger="click" placement="bottom-end">
                <!-- Trigger: săgeată jos cu border violet -->
                <span class="arrow-box">&#9662;</span>

                <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                  <el-dropdown-item @click.native="openAddProductModal(scope.row)">
                    {{ $t('general.edit') }}
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="deleteRow(scope.row)">
                    {{ $t('general.delete') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>

        </el-table>
        <button class="btn add mar-rt-10 mar-bt-5 mar-to-15" @click.prevent="openAddProductModal" :title="$t('general.add') + ' ' + $t('settingUsers.single')">
          <img src="/static/img/icons/add.png">
          {{$t('gestiune.addReteta')}}
        </button>
      </div>
    </div>

    <div v-if="!loadingRecipes && recipes.length" class="card mar-to-15">
      <div class="card-content">

        <div class="col-md-12 d-flex align-items-center" style="gap:10px; margin-bottom: 20px;">
          <p style="margin-bottom: 0px;">
            Produs utilizat în urmatoarele rețete
          </p>
        </div>

        <hr class="sm">

        <el-table :data="recipes" style="width: 100%">

          <!-- Rețetă -->
          <el-table-column label="Rețetă">
            <template slot-scope="scope">
              <strong style="color:#25396F;">
                {{ scope.row.denumire }}
              </strong>
            </template>
          </el-table-column>

          <!-- Categorie -->
          <el-table-column label="Categorie">
            <template slot-scope="scope">
              {{ scope.row.categorie || '-' }}
            </template>
          </el-table-column>

          <!-- Grupă -->
          <el-table-column label="Grupă">
            <template slot-scope="scope">
              {{ scope.row.grupa || '-' }}
            </template>
          </el-table-column>

          <!-- Consum -->
          <el-table-column label="Consum">
            <template slot-scope="scope">
              {{ parseFloat(String(scope.row.item.qty).replace(',', '.')).toFixed(3) }}
              {{ scope.row.item.um }}
            </template>
          </el-table-column>

          <!-- Ingredient principal -->
          <el-table-column label="Ingredient">
            <template slot-scope="scope">
              {{ scope.row.item.name || '-' }}
            </template>
          </el-table-column>

          <!-- Scăzământ -->
          <el-table-column label="Scăzământ">
            <template slot-scope="scope">
              <span v-if="scope.row.item.scazamantValue">
                {{ scope.row.item.scazamantValue }}
                {{ scope.row.item.scazamantType }}
              </span>
              <span v-else>
                -
              </span>
            </template>
          </el-table-column>

          <!-- Total ingrediente -->
          <el-table-column label="Ingrediente">
            <template slot-scope="scope">
              {{ scope.row.items ? scope.row.items.length : 0 }}
            </template>
          </el-table-column>

          <el-table-column label="Acțiuni">
            <template slot-scope="scope">

              <span
                v-if="scope.row.recipe && scope.row.recipe.parentPosId"
                @click.stop="goToProduct(scope.row)"
                style="cursor: pointer; text-decoration: underline; color: #409EFF;"
              >
                {{ $t('general.see') }}
              </span>

              <span v-else>
                -
              </span>

            </template>
          </el-table-column>

        </el-table>

      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">

        <div class="col-md-12 d-flex align-items-center" style="gap:10px; margin-bottom: 20px;">
          <p style="margin-bottom: 0px;">Detalii stoc (pe gestiuni)</p>
        </div>

        <hr class="sm">

        <div class="row mt-4 stock-cards-row">

          <div
            class="col-md-4 mb-4 stock-card-col"
            v-for="(g, index) in gestiuniStockFiltered"
            :key="index + '-' + g._id"
          >
            <div class="card-price stock-card">

              <!-- HEADER -->
              <div class="stock-header">
                <div>
                  <h5 class="stock-title">{{ g.name }}</h5>
                  <small class="stock-subtitle">Cod: {{ g.cod_gestiune }}</small>
                </div>
                <div class="stock-badge">
                  {{ (g.product && g.product.um) ? g.product.um : '-' }}
                </div>
              </div>

              <hr>

              <!-- LOADER -->
              <div v-if="g.loading" class="card-loader">
                <div class="spinner"></div>
                <span>Se încarcă stocul...</span>
              </div>

              <!-- CONTENT -->
              <div v-else>

                <!-- SUMMARY -->
                <div class="summary-grid">
                  <div class="summary-box">
                    <small>Cantitate</small>
                    <strong>{{ formatNumber(g.quantity) }}</strong>
                  </div>
                  <div class="summary-box">
                    <small>Valoare</small>
                    <strong>{{ formatNumber(g.value) }} RON</strong>
                  </div>
                  <div class="summary-box">
                    <small>Preț mediu</small>
                    <strong>{{ formatNumber(g.average_price) }} RON</strong>
                  </div>
                  <div class="summary-box">
                    <small>TVA</small>
                    <strong>{{ (g.product && g.product.vat_percent) ? g.product.vat_percent : 0 }}%</strong>
                  </div>
                </div>

                <hr>

                <!-- PRODUCT -->
                <div class="product-info">
                  <div class="info-row">
                    <span>Produs</span>
                    <strong>{{ (g.product && g.product.name) ? g.product.name : '-' }}</strong>
                  </div>
                  <div class="info-row">
                    <span>Categorie</span>
                    <strong>{{ (g.product && g.product.categorie) ? g.product.categorie : '-' }}</strong>
                  </div>
                  <div class="info-row">
                    <span>Monedă</span>
                    <strong>{{ (g.product && g.product.currency) ? g.product.currency : 'RON' }}</strong>
                  </div>
                  <div class="info-row">
                    <span>Ultimul update</span>
                    <strong>{{ g.date ? formatDate(g.date) : '-' }}</strong>
                  </div>
                </div>

              </div>

            </div>
          </div>

        </div>

      </div>
    </div>

    <div class="card mar-to-15">
      <div class="card-content">
        <div class="col-md-12 d-flex align-items-center" style="gap:10px; margin-bottom: 20px;">
          <p style="margin-bottom: 0px;">Detalii istoric miscari de stoc pe ultimele 7 ZILE (pe gestiuni)</p>
        </div>

        <hr class="sm">

        <div class="row mt-4">
          <div
            class="col-md-6 mb-4"
            v-for="(g, index) in gestiuniStockHistoryDetails"
            :key="index + '-' + g._id"
          >
            <!-- CARDUL SE AFISEAZA DOAR DACA ARE DATE SAU SE INCARCA -->
            <div
              v-if="g.loading || (g.products && g.products.length)"
              class="card-price stock-card"
            >

              <!-- HEADER -->
              <div class="stock-header">
                <div>
                  <h5 class="stock-title">{{ g.name }}</h5>
                  <small class="stock-subtitle">Cod: {{ g.cod_gestiune }}</small>
                </div>
                <div class="stock-badge">
                  {{ getProductStockInfo(g) }}
                </div>
              </div>

              <hr>

              <!-- LOADER -->
              <div v-if="g.loading" class="card-loader">
                <div class="spinner"></div>
                <span>Se încarcă istoricul...</span>
              </div>

              <!-- CONTENT -->
              <div v-else>

                <!-- TABEL ISTORIC MIȘCĂRI -->
                <div class="history-table-wrapper">
                  <table class="table history-table">
                    <thead>
                      <tr>
                        <th class="col-data">Data</th>
                        <th class="col-document">Document</th>
                        <th class="col-intrare text-right">Intrare</th>
                        <th class="col-iesire text-right">Ieșire</th>
                        <th class="col-stoc text-right">Stoc</th>
                        <th class="col-pret text-right">Preț</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="(prod, pIndex) in g.products">
                        <!-- Rânduri istoric -->
                        <tr
                          v-for="(h, hIndex) in prod.history"
                          :key="'hist-' + pIndex + '-' + hIndex"
                          class="history-row"
                        >
                          <td class="col-data">
                            <small>{{ formatDate(h.date) }}</small>
                          </td>
                          <td class="col-document">
                            <div class="doc-info" @click="goToDocument(h)">
                              <span
                                class="badge clickable"
                                :class="getDocumentBadgeClass(h.document_type)"
                              >
                                {{ formatDocumentType(h.document_type) }}
                              </span>
                              <span v-if="getDocumentNumber(h)" class="doc-number-black">
                                {{ getDocumentNumber(h) }}
                              </span>
                            </div>
                            <!-- LABEL PRODUS FABRICAT -->
                            <div
                              v-if="h.document && h.document.produced_posId"
                              class="produced-label"
                              @click.stop="goToProduced(h)"
                            >
                              <span class="label-badge">Produs fabricat</span>
                            </div>
                            <div v-if="h.observatii" class="text-muted">
                              <small>{{ h.observatii }}</small>
                            </div>
                          </td>
                          <td class="col-intrare text-right">
                            <span v-if="h.intrare && h.intrare !== 0" class="text-success">
                              <strong>{{ formatNumber(h.intrare) }}</strong>
                            </span>
                            <span v-else class="text-muted">-</span>
                          </td>
                          <td class="col-iesire text-right">
                            <span v-if="h.iesire && h.iesire !== 0" class="text-danger">
                              <strong>{{ formatNumber(h.iesire) }}</strong>
                            </span>
                            <span v-else class="text-muted">-</span>
                          </td>
                          <td class="col-stoc text-right">
                            <strong>{{ formatNumber(h.running) }}</strong>
                          </td>
                          <td class="col-pret text-right">
                            <span v-if="h.pret">{{ formatNumber(h.pret) }} RON</span>
                            <span v-else class="text-muted">-</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <vmodal name="editGestionModal" height="auto" width="600">
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <p>{{ $t('gestiune.editPrice') }}</p>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.pretVanzare') }}</label>
                  <input v-model="editForm.price" type="number" class="form-control" placeholder="Introdu prețul">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.currency') }}</label>
                  <select v-model="editForm.currency" class="form-control">
                    <option value="RON">RON</option>
                    <option value="EUR">EUR</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{ $t('gestiune.stocMinim') }}</label>
                  <input v-model="editForm.minStock" type="number" class="form-control" placeholder="Introdu stocul minim">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="button-group">
              <a @click="closeEditModal" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
              <button @click.prevent="saveGestionEdit" class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </vmodal>
    <vmodal name="addProductModal" height="auto" width="970" class="addProductModal">
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <p>{{ $t('gestiune.addReteta') }}</p>
          </div>
          <div class="modal-body">
            <div class="row mt-3">
              <div class="col-md-3">
                <div class="form-group mt-3">
                  <label>{{ $t('gestiune.gestiune') }}*</label>
                  <select v-model="selectedCategory" class="form-control" @change="onCategoryChange">
                    <option value="">All</option>
                    <option
                      v-for="(cat, index) in limitedCategories"
                      :key="index"
                      :value="cat.value"
                    >
                      {{ cat.label }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-5">
                <div class="form-group">
                  <label>{{$t('gestiune.productName')}}*</label>
                  <v-select
                    v-model="productNameRecipe"
                    :options="searchResults"
                    label="name"
                    placeholder="Caută un produs..."
                    :filterable="false"
                    @search="fetchProducts"
                    @input="onProductSelect"
                  >
                    <template #no-options>
                      <span v-if="!loadingProducts">Niciun produs găsit</span>
                    </template>
                  </v-select>

                  <div class="v-select-loader" v-if="loadingProducts"></div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t('gestiune.codeProduct') }}</label>
                  <input type="text" :placeholder="$t('gestiune.codeProduct')" v-model="codeProductRecipe" class="form-control" disabled/>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t('gestiune.um') }}</label>
                  <input type="text" :placeholder="$t('gestiune.um')" v-model="umRecipe" class="form-control" disabled/>
                </div>
              </div>
            </div>

            <div class="row mt-3">
              <div class="col-md-4">
                <div class="form-group">
                  <label>{{ $t('gestiune.cantitate') }}*</label>
                  <input
                    type="number"
                    step="any"
                    :placeholder="$t('gestiune.cantitate')"
                    v-model="quantityRecipe"
                    class="form-control"
                    @keydown="blockCommaKey"
                    @input="sanitizeQuantityRecipe"
                  />
                  <small style="display: block; font-size: 12px; font-style: italic; color: #7C8DB5; margin-top: 4px;">
                    {{ $t('gestiune.cantitateHint') }}
                  </small>
                </div>
              </div>

              <!-- Termen de Valabilitate -->
              <!-- <div class="col-md-4">
                <div class="form-group">
                  <label class="mr-2">{{ $t('gestiune.termenValabilitate') }}</label>
                  <div class="d-flex align-items-center">
                    <input type="number" v-model="validityTerm" class="form-control mr-2" placeholder="0" style="width: 60%;" />
                    <select v-model="validityUnit" class="form-control" style="width: 40%;">
                      <option value="ore">{{ $t('gestiune.ore') }}</option>
                      <option value="zile">{{ $t('gestiune.zile') }}</option>
                    </select>
                  </div>
                  <span style="font-size: 12px; font-style: italic;">Valoare 0 - perioada de valabilitate</span>
                </div>
              </div> -->

              <div class="col-md-4">
                <div class="form-group">
                  <label class="mr-2">{{ $t('gestiune.scazamant') }}</label>
                  <div class="d-flex align-items-center">
                    <input type="number" v-model="scazamantValue" class="form-control mr-2" placeholder="0" style="width: 60%;"/>
                    <select v-model="scazamantType" class="form-control" style="width: 40%;">
                      <option value="" disabled>Selectează opțiunea</option>
                      <option value="valoare">{{ $t('gestiune.valoare') }}</option>
                      <option value="procent">{{ $t('gestiune.procent') }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="button-group">
              <a @click="closeModal" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
              <button @click.prevent="saveRecipe" class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </vmodal>
    <vmodal name="addProduct" height="auto" width="970" class="addProductModal">
      <div class="card">
        <div class="card-content">
          <div class="modal-header">
            <p>{{ $t('gestiune.addProduct') }}</p>
          </div>
          <div class="modal-body">
            <div class="row mt-3">
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.productName') }}*</label>
                  <input type="text" :placeholder="$t('gestiune.productName')" v-model="name" class="form-control"/>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.productDescription') }}*</label>
                  <input type="text" :placeholder="$t('gestiune.productDescription')" v-model="description" class="form-control"/>
                </div>
              </div>
              <div class="col-md-6">
                  <div class="form-group">
                      <label>{{ $t('gestiune.type') }}*</label>
                      <select v-model="type" class="form-control">
                        <option value="" disabled>Selectează opțiunea</option>
                        <option
                          v-for="(cat, index) in limitedCategories"
                          :key="index"
                          :value="cat.value"
                        >
                          {{ cat.label }}
                        </option>
                      </select>
                  </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.um') }} *</label>
                  <select v-model="umProduct" class="form-control" :disabled="type === 'Semifabricate (Reteta)'">
                    <template v-for="unit in mesurementsUnits">
                      <option :value="unit.short">{{unit.short}}</option>
                    </template>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.currency') }} *</label>
                  <select v-model="currencyProduct" class="form-control">
                      <option value="RON">RON</option>
                      <option value="EUR">EURO</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>{{ $t('gestiune.codeProduct') }}*</label>
                  <input type="text" :placeholder="$t('gestiune.codeProduct')" v-model="code" class="form-control"/>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <div class="button-group">
              <a @click="closeProduct" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
              <button @click.prevent="addProduct" class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
            </div>
          </div>
        </div>
      </div>
    </vmodal>
  </div>
</template>

<script>
  // import GeneralTopBar from 'src/components/UIComponents/Inputs/generalTopBar.vue'
  import swal from 'sweetalert2'
  export default {
    // components: {
    //   GeneralTopBar
    // },
    data () {
      return {
        loadingProducts: false,
        selectedCategory: '',
        recipes: [],
        loadingRecipes: false,
        isGestionProduct: true,
        gestiuniStock: [],
        gestiuniStockHistoryDetails: [],
        stockByGestiune: {},
        name: '',
        validityValue: null,
        description: '',
        type: '',
        umProduct: 'BUC',
        currencyProduct: 'RON',
        code: '',
        productName: '',
        productDescription: '',
        productType: '',
        um: 'buc',
        price: '',
        currency: '',
        codeProduct: '',
        companyID: '',
        product: {},
        gestiunePrices: {},
        vats: [],
        cotaTva: '',
        id: '',
        validityUnit: 'ore',
        isEditing: false,
        editingProduct: null,
        modelValidate: {
          productName: { required: true },
          productType: { required: true },
          productDescription: { required: true },
          productNameRecipe: { required: true },
          name: { required: true },
          description: { required: true },
          um: {required: true}
        },
        validityTerm: 0,
        scazamantValue: 0,
        scazamantType: 'valoare',
        productNameRecipe: '',
        downloadMethod: 'bon_productie',
        productTypeRecipe: '',
        codeProductRecipe: '',
        umRecipe: '',
        quantityRecipe: 0,
        // activeProduct: true,
        tableData: [],
        locations: [],
        gestiuniList: [],
        searchResults: [],
        groupedLocationsData: [],
        cantitateRezultata: '',
        gestionData: [
          { gestionType: 'Magazin', quantity: 10, price: 50, currency: 'RON', minStock: 5 },
          { gestionType: 'Depozit', quantity: 15, price: 100, currency: 'EUR', minStock: 3 }
        ],
        editForm: {
          price: '',
          currency: 'RON',
          minStock: ''
        },
        is_external: false,
        isProductSelected: false,
        mesurementsUnits: [],
        productId: null,
        highlightRowId: null,
        loadingStockDetails: false
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      const posId = this.route.params.id
      const vatNumberProduct = this.route.params.vatNumber
      if (!posId || !vatNumberProduct) {
        console.error('Missing product ID')
        return
      }

      this.productId = posId
      this.companyID = this.$session.get('selectedCompany')

      this.loadMesurementsUnits()
      this.fetchLocation()
      this.fetchGestiuni()

      this.getProductDetails(posId, vatNumberProduct)
        .then(() => {
          if (this.is_external === 1) {
            swal({
              title: 'Atenție',
              text: 'Acest produs este gestionat din Taptasty. Modificările făcute acolo vor fi reflectate automat și în acest nomenclator.',
              type: 'warning'
            })
          }

          this.fetchProductRecipes()
          this.fetchStockDetails()
          this.fetchStockHistoryDetails()

          this.$nextTick(() => {
            const highlightId = this.route.query.highlight
            console.log('Highlight ID from query:', highlightId)

            if (highlightId) {
              this.highlightRowId = highlightId

              this.$nextTick(() => {
                this.scrollToRecipeTable()
              })
            }
          })
        })
      // this.getRecipeDetails(productId)
    },
    watch: {
      vats (newVats) {
        if (newVats && newVats.length > 0 && this.product && this.product.vat_percent != null) {
          const vat = newVats.find(v => parseFloat(v.amount) === parseFloat(this.product.vat_percent))
          this.cotaTva = vat ? vat.amount.toString() : ''
        }
      },
      type (newVal) {
        if (newVal === 'Semifabricate (Reteta)') {
          this.umProduct = 'BUC'
        }
      }
    },
    computed: {
      hasRecipe () {
        return this.product && this.product.reteta && this.product.reteta.items && this.product.reteta.items.length > 0
      },
      isRecipeProduct () {
        return this.product && this.productType && this.productType.includes('Reteta')
      },
      filteredProductTypes () {
        const types = [
          { value: 'Marfa', label: 'Marfa', externalOnly: false },
          { value: 'Materii prime', label: 'Materii prime', externalOnly: true },
          { value: 'Materiale consumabile', label: 'Materiale consumabile', externalOnly: true },
          { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)', externalOnly: true },
          { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)', externalOnly: false },
          { value: 'Produs rezidual', label: 'Produs rezidual', externalOnly: true },
          { value: 'Ambalaje', label: 'Ambalaje', externalOnly: true },
          { value: 'Obiecte de inventar', label: 'Obiecte de inventar', externalOnly: true }
        ]

        if (this.is_external === 1) {
          // Când is_external = 1, afișează doar cele cu externalOnly: false
          return types.filter(type => !type.externalOnly)
        } else {
          // Când is_external = 0, afișează toate
          return types
        }
      },
      limitedCategories () {
        return [
          { value: 'Materii prime', label: 'Materii prime' },
          { value: 'Marfa', label: 'Marfa' },
          { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' },
          { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' },
          { value: 'Ambalaje', label: 'Ambalaje' },
          { value: 'Materiale consumabile', label: 'Materiale consumabile' }
        ]
      },
      filteredGestiuni () {
        if (!this.route || !this.route.params || !this.route.params.vatNumber) return []

        return this.gestiuniList.filter(g =>
          g.vatNumber === this.route.params.vatNumber &&
          (g.categorie === 'Produs finit (Reteta)' || g.categorie === 'Marfa')
        )
      },
      gestiuniStockFiltered () {
        return this.gestiuniStock.filter(g => g.loading || (g.stock && g.stock.length))
      }
    },
    methods: {
      blockCommaKey (event) {
        if (event.key === ',' || event.key === 'Comma') {
          event.preventDefault()
        }
      },
      sanitizeQuantityRecipe (event) {
        const value = event.target.value.replace(/,/g, '.')
        if (value !== event.target.value) {
          this.quantityRecipe = value
        }
      },
      scrollToRecipeTable () {
        this.$nextTick(() => {
          const comp = this.$refs.recipeTable
          if (!comp) return

          const el = comp.$el || comp
          const rect = el.getBoundingClientRect()

          let scrollContainer = el.parentElement
          while (scrollContainer && scrollContainer !== document.body) {
            const style = window.getComputedStyle(scrollContainer)
            if (style.overflow === 'auto' || style.overflow === 'scroll' ||
                style.overflowY === 'auto' || style.overflowY === 'scroll') {
              break
            }
            scrollContainer = scrollContainer.parentElement
          }

          if (scrollContainer && scrollContainer !== document.body) {
            const containerRect = scrollContainer.getBoundingClientRect()
            const relativeTop = rect.top - containerRect.top + scrollContainer.scrollTop - 200

            scrollContainer.scrollTo({
              top: relativeTop,
              behavior: 'smooth'
            })
          } else {
            window.scrollTo({
              top: window.scrollY + rect.top - 200,
              behavior: 'smooth'
            })
          }
        })
      },
      tableRowClassName ({ row }) {
        if (
          this.highlightRowId &&
          (row.posId === this.highlightRowId ||
          row.posId === this.highlightRowId)
        ) {
          return 'highlight-row'
        }
        return ''
      },
      resetSelectedProduct () {
        this.isProductSelected = false
        this.posId = null
        this.productNameRecipe = ''
        this.codeProductRecipe = ''
        this.umRecipe = ''
        this.searchResults = [] // opțional, dacă vrei să golești lista
      },
      getLocationName (externalLocationId) {
        if (!this.locations || !externalLocationId) return ''

        const location = this.locations.find(
          loc => loc.true_id === externalLocationId
        )

        return location ? location.name : ''
      },
      onCategoryChange () {
        this.resetSelectedProduct()
      },
      async loadMesurementsUnits () {
        this.mesurementsUnits = await this.getMesurementsUnits()
      },
      async fetchLocation () {
        const dataToSend = {
          company_id: this.companyID,
          token: this.$session.get('token')
        }

        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.locations) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea locațiilor.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            return
          }

          this.locations = response.data.locations

          const groups = {}
          this.locations.forEach(location => {
            const vat = location.inv_fiscal_code || 'Fără cod fiscal'
            if (!groups[vat]) groups[vat] = []
            groups[vat].push(location)
          })

          this.groupedLocationsData = Object.entries(groups).map(([vat, locations]) => ({ vat, locations }))

          console.log('Fetched locations:', this.locations)
          console.log('Grouped locations:', this.groupedLocationsData)
        })
      },
      async fetchProductRecipes () {
        this.loadingRecipes = true

        try {
          const url =
            `${process.env.API_BASE_URL_GESTIUNE}:4443/retete/by-product/${this.productId}` +
            `?externalCompanyId=${encodeURIComponent(this.companyID)}`

          const response = await fetch(url)
          const data = await response.json()

          if (!data) {
            swal({
              title: 'Eroare!',
              text: 'Eroare la preluarea rețetelor.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            return
          }

          this.recipes = data.retete || []

          console.log('Recipes found:', this.recipes)
        } catch (error) {
          console.error('Error fetching recipes:', error)

          swal({
            title: 'Eroare!',
            text: 'Eroare la server.',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          })
        } finally {
          this.loadingRecipes = false
        }
      },
      async fetchStockDetails () {
        this.loadingStockDetails = true

        try {
          if (!this.gestiuniList.length) {
            return
          }

          this.gestiuniStock = this.gestiuniList.map(g => ({
            ...g,
            loading: true,
            stock: [],
            product: null,
            date: null
          }))

          const requests = this.gestiuniList.map(async (g, index) => {
            try {
              const url =
                `${process.env.API_BASE_URL_GESTIUNE}:4443/stock` +
                `?gestiune=${encodeURIComponent(g._id)}` +
                `&product_ids=${encodeURIComponent(this.productId)}` +
                `&vatNumber=${encodeURIComponent(this.route.params.vatNumber)}` +
                `&externalCompanyId=${encodeURIComponent(this.companyID)}`

              const res = await fetch(url)
              const data = await res.json()

              const stockItem =
                data.stock &&
                data.stock.length
                  ? data.stock[0]
                  : null

              this.$set(this.gestiuniStock, index, {
                ...g,
                loading: false,
                stock: data.stock || [],
                product: stockItem.productDetails || null,
                quantity: stockItem.quantity || 0,
                value: stockItem.value || 0,
                average_price: stockItem.average_price || 0,
                date: data.date || null
              })
            } catch (e) {
              this.$set(this.gestiuniStock, index, {
                ...g,
                loading: false,
                stock: [],
                product: null,
                quantity: 0,
                value: 0,
                average_price: 0,
                date: null
              })
            }
          })

          await Promise.all(requests)
        } catch (error) {
          console.error(error)

          swal({
            title: 'Eroare!',
            text: 'Eroare server',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          })
        } finally {
          this.loadingStockDetails = false
        }
      },
      getFirstProductHistory (gestiune) {
        if (!gestiune.products || !gestiune.products.length) return []
        const firstProduct = gestiune.products[0]
        return (firstProduct.history || []).slice(0, 5) // ultimele 5 mișcări
      },

      getDocumentLabel (h) {
        if (typeof h.document === 'string') return h.document
        if (h.document && h.document.type) return h.document.type.toUpperCase()
        return h.document_type || '-'
      },

      getDocumentBadgeClass (docType) {
        const map = {
          'STOCK_INITIAL': 'badge-info',
          'BON_CONSUM': 'badge-danger',
          'NIR': 'badge-success',
          'TRANSFER': 'badge-warning',
          'INVENTAR': 'badge-primary',
          'AJUSTARE': 'badge-default'
        }
        return map[docType] || 'badge-default'
      },

      getProductStockInfo (g) {
        if (!g.products || !g.products.length) return '-'
        const prod = g.products[0]
        const qty = prod.quantity !== undefined ? this.formatNumber(prod.quantity) : '-'
        const um = this.um || 'buc'
        return `Stoc: ${qty} ${um}`
      },

      formatDocumentType (docType) {
        if (!docType) return '-'
        // Înlocuiește underscore cu spațiu
        return docType.replace(/_/g, ' ')
      },

      // Badge colorat în funcție de tipul documentului
      getDocumentNumber (h) {
        if (!h.document) return null
        if (typeof h.document === 'string') return null

        const numar = h.document.numar_document || h.document.nirNumber || h.document.number || ''
        const serie = h.document.series || ''

        if (numar && serie) return `${serie} / ${numar}`
        if (numar) return numar
        if (serie) return serie
        return null
      },

      async fetchStockHistoryDetails () {
        this.loadingStockDetails = true

        try {
          if (!this.gestiuniList.length) return

          const end = new Date()
          const start = new Date()
          start.setDate(start.getDate() - 7)

          const startISO = start.toISOString()
          const endISO = end.toISOString()

          // init cards
          this.gestiuniStockHistoryDetails = this.gestiuniList.map(g => ({
            ...g,
            loading: true,
            products: [],
            total: 0,
            currentPage: 1,
            pageSize: 20
          }))

          const requests = this.gestiuniList.map(async (g, index) => {
            try {
              let url =
                `${process.env.API_BASE_URL_GESTIUNE}:4443/stock_history_advanced_v2` +
                `?externalCompanyId=${encodeURIComponent(this.companyID)}` +
                `&product_id=${encodeURIComponent(this.productId)}` +
                `&startDate=${encodeURIComponent(startISO)}` +
                `&endDate=${encodeURIComponent(endISO)}`

              if (g._id) {
                url += `&gestiune=${encodeURIComponent(g._id)}`
              }

              if (g.externalLocationId) {
                url += `&externalLocationId=${encodeURIComponent(g.externalLocationId)}`
              }

              const res = await fetch(url)
              const data = await res.json()

              console.log(`Stock history for gestiune ${g.name}:`, data)

              // Mapare date API pe structura componentei
              this.$set(this.gestiuniStockHistoryDetails, index, {
                ...g,
                loading: false,
                // Răspunsul API conține direct array-ul de produse
                products: data.products || [],
                total: data.total || 0,
                currentPage: data.currentPage || 1,
                pageSize: data.pageSize || 20,
                gestiune: data.gestiune || g._id
              })
            } catch (e) {
              console.error(`Eroare gestiune ${g.name}:`, e)
              this.$set(this.gestiuniStockHistoryDetails, index, {
                ...g,
                loading: false,
                products: [],
                total: 0,
                currentPage: 1,
                pageSize: 20
              })
            }
          })

          await Promise.all(requests)
        } catch (error) {
          console.error(error)
          swal({
            title: 'Eroare!',
            text: 'Eroare server',
            type: 'error',
            timer: 3000,
            showConfirmButton: false
          })
        } finally {
          this.loadingStockDetails = false
        }
      },
      goToDocument (entry) {
        try {
          if (!entry || !entry.document_type) {
            return false
          }

          const type = entry.document_type
          const doc = entry.document || {}

          const id = entry.document_id || doc._id

          if (!id) {
            return false
          }

          // NIR
          if (type === 'NIR') {
            if (!doc.nirNumber) return false

            return this.$router.push({
              path: `/management/entries/edit/${id}`,
              query: {
                nirNumber: doc.nirNumber,
                data_document: doc.data_document,
                vatNumberFurnizor: doc.vatNumberFurnizor,
                series: doc.series
              }
            })
          }

          if (type === 'BON_TRANSFER') {
            if (!doc.series || !doc.documentNumber) return false

            return this.$router.push({
              path: `/management/transfer/edit/${doc.series}/${doc.documentNumber}`
            })
          }

          if (type === 'BON_PRODUCTIE') {
            if (!doc.series || !doc.documentNumber) return false

            return this.$router.push({
              path: `/management/bon-product/edit/${doc.series}/${doc.documentNumber}`
            })
          }

          if (type === 'BON_FISCAL') {
            if (!doc._id) return false

            return this.$router.push({
              name: 'ManagementBonFiscalView',
              params: { id: doc._id }
            })
          }

          if (type === 'AVIZ') {
            if (!doc.series || !doc.invoiceNumber) return false

            const invoiceId = `${doc.series}-${doc.invoiceNumber}`

            return this.$router.push({
              path: `/management/outputs/${invoiceId}`,
              query: { edit: 'true' }
            })
          }

          if (type === 'BON_CASARE') {
            if (!doc.series || !doc.documentNumber) return false

            return this.$router.push({
              path: `/management/wasted/edit/${doc.series}/${doc.documentNumber}`
            })
          }

          if (type === 'BON_CONSUM') {
            if (!doc.series || !doc.documentNumber) return false

            return this.$router.push({
              path: `/management/stocks/edit/${doc.series}/${doc.documentNumber}`
            })
          }

          return false
        } catch (error) {
          return false
        }
      },
      goToProduced (entry) {
        if (!entry || !entry.document || !entry.document.produced_posId) return

        const producedId = entry.document.produced_posId
        const vatNumber = entry.document.company && entry.document.company.vatNumber
          ? entry.document.company.vatNumber
          : ''

        this.$router.push({
          path: `/management/nomenclator-products/edit/${producedId}/${vatNumber}`,
          query: {
            highlight: entry.item && entry.item.product_id
              ? entry.item.product_id
              : entry.document.produced_posId
          }
        })
      },
      goToProduct (row) {
        console.log('row', row)
        const id = row.recipe.parentPosId
        const vatNumber = this.route.params.vatNumber

        this.$router.push(
          `/management/nomenclator-products/edit/${id}/${vatNumber}`
        )
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) {
            this.saveProduct()
          }
        })
      },
      openEditModal () {
        this.$modal.show('editGestionModal')
      },
      closeEditModal () {
        this.$modal.hide('editGestionModal')
      },
      async fetchProducts (searchTerm) {
        if (!searchTerm || searchTerm.length < 2) {
          this.searchResults = []
          return
        }

        this.loadingProducts = true
        try {
          let categorieParam = ''

          if (this.selectedCategory) {
            // dacă e selectată o categorie
            categorieParam = `&categorie=${encodeURIComponent(this.selectedCategory)}`
          } else {
            // dacă nu e selectată, trimitem toate categoriile
            const allCategories = this.limitedCategories.map(c => c.value).join(',')
            categorieParam = `&categorie=${encodeURIComponent(allCategories)}`
          }

          const vatNumberParam = this.route.params.vatNumber ? `&vatNumber=${encodeURIComponent(this.route.params.vatNumber)}` : ''

          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}&name=${encodeURIComponent(searchTerm)}${categorieParam}${vatNumberParam}`)
          const data = await response.json()

          if (Array.isArray(data.products)) {
            this.searchResults = [
              ...data.products,
              { id: 'add', name: '➕ Adaugă produs' }
            ]
          } else {
            this.searchResults = [
              { id: 'add', name: '➕ Adaugă produs' }
            ]
          }
        } catch (error) {
          console.error('Error fetching products:', error)
          this.searchResults = [
            { id: 'add', name: '➕ Adaugă produs' }
          ]
        } finally {
          this.loadingProducts = false
        }
      },
      async loadVats (locationId) {
        this.vats = await this.fetchVats(locationId)
        console.log(this.vats)
      },
      formatNumber (value) {
        if (value === null || value === undefined || value === '') {
          return 0
        }

        // taie zgomotul JS (max 4 zecimale)
        return parseFloat(Number(value).toFixed(4))
      },
      async copyProduct () {
        console.log('Initiating product copy...', this.product)

        if (!this.codeProduct) {
          swal('Eroare', 'Nu există cod de produs pentru copiere!', 'error')
          return
        }

        // Construim select-ul pentru VAT
        const vatOptionsHtml = `
          <select id="swal-vat-select" class="form-control">
            <option value="">Selectează locația după VAT</option>
            ${this.groupedLocationsData
              .map(group => {
                const disabled = group.vat === this.product.vatNumber ? 'disabled' : ''
                return `<option value="${group.vat}" ${disabled}>
                  VAT: ${group.vat} — ${group.locations.map(l => l.name).join(', ')}
                </option>`
              })
              .join('')}
          </select>
        `

        try {
          // --- Select VAT ---
          let selectedVat = null
          try {
            const confirm = await swal({
              title: 'Alege locația pentru copiere',
              html: vatOptionsHtml,
              type: 'info',
              showCancelButton: true,
              confirmButtonText: 'Copiază',
              cancelButtonText: 'Renunță'
            })
            if (!confirm) return // apasare Cancel
            const selectEl = document.getElementById('swal-vat-select')
            selectedVat = selectEl ? selectEl.value : null
          } catch (swalCancel) {
            if (swalCancel === 'cancel') return // user apasa Cancel → iesim fără eroare
            throw swalCancel
          }

          if (!selectedVat) {
            swal('Atenție', 'Trebuie să selectezi o locație!', 'warning')
            return
          }

          const targetGroup = this.groupedLocationsData.find(g => g.vat === selectedVat)
          if (!targetGroup || !targetGroup.locations.length) {
            swal('Eroare', 'Locația selectată nu este validă!', 'error')
            return
          }

          // --- Loading swal ---
          swal({
            type: 'info',
            title: 'Se copiază produsul...',
            text: 'Așteptați câteva momente',
            showConfirmButton: false,
            allowOutsideClick: false
          })

          // --- Primul request ---
          let response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/products/copy`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              sourceExternalCompanyId: this.companyID,
              targetExternalCompanyId: this.companyID,
              product_code: this.product.product_code,
              product_id: this.product._id,
              sourceVatNumber: this.product.vatNumber,
              targetVatNumber: selectedVat
            })
          })

          // --- Produs existent (overwrite) ---
          if (response.status === 409) {
            let errJson = {}
            try { errJson = await response.json() } catch (e) {}

            let confirmOverwrite = false
            try {
              confirmOverwrite = await swal({
                title: 'Produs deja existent',
                text: errJson.error || 'Produsul există deja în locația selectată. Vrei să îl suprascrii?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Da, suprascrie',
                cancelButtonText: 'Nu'
              })
            } catch (swalCancel) {
              if (swalCancel === 'cancel') return // user apasa Nu → iesim fără eroare
              throw swalCancel
            }

            if (!confirmOverwrite) {
              swal.close()
              return
            }

            swal({
              title: 'Se suprascrie produsul...',
              text: 'Așteptați câteva momente',
              showConfirmButton: false,
              allowOutsideClick: false
            })

            response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/products/copy`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                sourceExternalCompanyId: this.companyID,
                targetExternalCompanyId: this.companyID,
                product_code: this.product.product_code,
                product_id: this.product._id,
                sourceVatNumber: this.product.vatNumber,
                targetVatNumber: selectedVat,
                overwrite: 1
              })
            })
          }

          if (!response.ok) {
            const errText = await response.text()
            throw new Error(errText)
          }

          const data = await response.json()
          console.log('Copy result:', data)

          swal({
            title: 'Succes',
            text: 'Produsul a fost copiat cu succes!',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })
        } catch (error) {
          // aici intră doar erorile reale de fetch, nu Cancel
          if (error === 'cancel') return // ignorăm cancel
          console.error('Error copying product:', error)
          swal({
            title: 'Eroare',
            text: `Nu s-a putut copia produsul: ${error.message}`,
            type: 'error',
            timer: 9000,
            showConfirmButton: false
          })
        }
      },
      async getProductDetails (posId, vatNumberProduct) {
        try {
          swal({
            type: 'warning',
            title: 'Se încarcă produsul...',
            showConfirmButton: false,
            allowOutsideClick: false
          })

          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/nomenclator`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              posId: posId,
              externalCompanyId: this.companyID,
              vatNumber: vatNumberProduct
            })
          })

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

          const data = await response.json()

          this.product = data
          // this.activeProduct = data.is_active
          this.id = data._id || ''
          this.productName = data.name || ''
          this.productType = data.categorie || ''
          this.um = data.um || ''
          this.price = data.price ? data.price.toString() : ''
          this.currency = data.currency || ''
          this.codeProduct = data.product_code || ''
          this.is_external = data.is_external
          this.externalId = data.externalId || ''
          this.validityValue = data.validity && data.validity.value ? data.validity.value : ''
          this.validityUnit = data.validity && data.validity.unit ? data.validity.unit : 'ore'
          this.posId = data.posId

          if (data.prices && typeof data.prices === 'object') {
            this.gestiunePrices = {}  // golim orice preț anterior
            Object.entries(data.prices).forEach(([gestiuneId, price]) => {
              // Vue 2: folosește $set ca să fie reactiv
              this.$set(this.gestiunePrices, gestiuneId, price)
            })
          }

          if (data.reteta && data.reteta.substract_using) {
            this.downloadMethod = data.reteta.substract_using
          } else {
            this.downloadMethod = ''
          }

          if (this.hasRecipe && data.reteta && Array.isArray(data.reteta.items)) {
            this.tableData = data.reteta.items.map(item => ({
              posId: item.productDetails ? item.productDetails._id : item.posId,
              productNameRecipe: item.productDetails ? item.productDetails.name : '',
              productTypeRecipe: item.productDetails ? item.productDetails.categorie : '',
              codeProductRecipe: item.productDetails ? item.productDetails.product_code : '',
              umRecipe: item.um || '',
              quantityRecipe: item.qty || 0,
              scazamantValue: item.scazamantValue,
              scazamantType: item.scazamantType
            }))

            this.cantitateRezultata = data.reteta.cantitate_rezultata || ''
          } else {
            this.tableData = []
          }

          console.log(this.is_external)

          if (this.is_external !== 1) {
            await this.loadVats(data.externalLocationId)
          } else {
            this.cotaTva = data.vat_percent != null ? data.vat_percent.toString() : ''
          }
        } catch (error) {
          console.error('Error fetching product details:', error)
        } finally {
          swal.close()
        }
      },
      async saveRecipe () {
        if (!this.productNameRecipe || !this.quantityRecipe) {
          swal({
            title: 'Eroare',
            text: 'Completează câmpurile obligatorii: Denumire produs și Cantitate.',
            type: 'error',
            timer: 3000,
            showConfirmButton: true
          })
          return
        }

        const hasScazamantValue = this.scazamantValue !== '' &&
          this.scazamantValue !== null &&
          this.scazamantValue !== undefined &&
          !isNaN(parseFloat(this.scazamantValue)) &&
          parseFloat(this.scazamantValue) !== 0

        if (hasScazamantValue && !this.scazamantType) {
          swal({
            title: 'Eroare',
            text: 'Dacă completezi Scăzământ, trebuie să selectezi și tipul (valoare sau procent).',
            type: 'error',
            timer: 3000,
            showConfirmButton: true
          })
          return
        }

        const newProduct = {
          posId: this.posId,
          productNameRecipe: this.productNameRecipe,
          productTypeRecipe: this.productTypeRecipe,
          codeProductRecipe: this.codeProductRecipe,
          umRecipe: this.umRecipe,
          quantityRecipe: this.quantityRecipe,
          scazamantValue: this.scazamantValue,
          scazamantType: this.scazamantType
        }

        if (this.isEditing && this.editingProduct) {
          const index = this.tableData.findIndex(p => p === this.editingProduct)
          if (index !== -1) {
            this.tableData.splice(index, 1, newProduct)
          }
        } else {
          this.tableData = [...this.tableData, newProduct]
        }

        try {
          await this.saveOrFetchRecipe()
          // await this.getProductDetails(id, vatNumberProduct)
        } catch (error) {
          console.error('Error while saving recipe:', error)
        }

        this.$modal.hide('addProductModal')
        swal({
          title: 'Succes',
          text: 'Rețeta a fost salvată cu succes.',
          type: 'success',
          timer: 2000,
          showConfirmButton: false
        })
      },
      async saveOrFetchRecipe () {
        try {
          swal({
            type: 'warning',
            title: 'Se salveaza reteta...',
            showConfirmButton: false,
            allowOutsideClick: false
          })

          const bodyData = {
            parentPosId: this.id,
            items: this.tableData.map(item => ({
              name: item.productNameRecipe,
              posId: item.posId,
              qty: item.quantityRecipe,
              um: item.umRecipe,
              scazamantValue: item.scazamantValue,
              scazamantType: item.scazamantType
            })),
            externalCompanyId: this.companyID
          }

          if (this.cantitateRezultata) {
            bodyData.cantitate_rezultata = parseFloat(this.cantitateRezultata)
          }

          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/reteta`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(bodyData)
          })

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

          const data = await response.json()
          console.log('Recipe updated:', data)

          swal({
            icon: 'success',
            title: 'Rețetă salvată!',
            timer: 1500,
            showConfirmButton: false
          })
        } catch (error) {
          console.error('Error updating recipe:', error)
          swal({
            icon: 'error',
            title: 'Eroare la salvare!',
            text: 'A apărut o problemă la salvarea rețetei.'
          })
        }
      },
      formatDate (date) {
        if (!date) return '-'

        return new Date(date).toLocaleString('ro-RO')
      },
      async saveProduct () {
        if (!this.um) {
          swal({
            title: 'Eroare',
            text: 'Te rugăm să selectezi unitatea de măsură (UM)!',
            type: 'error',
            showConfirmButton: true,
            allowOutsideClick: false,
            allowEscapeKey: false
          })
          return
        }

        try {
          swal({
            type: 'warning',
            title: 'Se salveaza produsul...',
            showConfirmButton: false,
            allowOutsideClick: false
          })

          const productData = {
            name: this.productName,
            product_code: this.codeProduct,
            // active: this.activeProduct,
            is_with_vat: true,
            vat_percent: parseInt(this.cotaTva),
            currency: this.currency,
            um: this.um,
            externalId: this.externalId || '',
            externalCompanyId: this.companyID,
            vatNumber: this.route.params.vatNumber,
            is_external: this.is_external,
            categorie: this.productType,
            validity: this.validityValue ? {
              value: this.validityValue,
              unit: this.validityUnit
            } : null,
            prices: this.gestiunePrices
          }

          if (this.productId) {
            productData.posId = this.productId
          }

          const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/nomenclator`

          const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(productData)
          })

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

          const data = await response.json()
          console.log('Product saved successfully:', data)

          if (this.cantitateRezultata) {
            await this.saveOrFetchRecipe()
          }

          swal({
            title: 'Succes',
            text: 'Produsul a fost salvat cu succes.',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })

          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
        } catch (error) {
          console.error('Error saving product:', error)

          swal({
            title: 'Error',
            text: 'There was an error saving the product.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        } finally {
          swal.close()
        }
      },
      async addProduct () {
        if (!this.name || !this.code || !this.type) {
          swal({
            title: 'Eroare',
            text: 'Toate câmpurile obligatorii trebuie completate!',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        const vatNumberProduct = this.route.params.vatNumber

        const productData = {
          name: this.name,
          product_code: this.code,
          price: parseFloat(this.priceProduct),
          is_with_vat: true,
          vat_percent: parseInt(this.cotaTva),
          currency: this.currencyProduct,
          um: this.umProduct,
          externalId: '',
          externalCompanyId: this.companyID,
          is_external: 0,
          vatNumber: vatNumberProduct,
          categorie: this.type,
          pret_vanzare: []
        }

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/nomenclator`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(productData)
          })

          const data = await response.json()

          if (!response.ok) {
            swal({
              title: 'Eroare',
              text: data.details || 'A apărut o eroare la salvarea produsului.',
              type: 'error',
              timer: 4000,
              showConfirmButton: false
            })
            return
          }

          // succes
          await this.fetchProducts()
          this.searchResults.push(data)

          this.productNameRecipe = data
          this.codeProductRecipe = data.product_code
          this.umRecipe = data.um
          this.posId = data._id

          swal({
            title: 'Succes',
            text: 'Produsul a fost salvat cu succes.',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })

          this.$modal.hide('addProduct')
          this.resetFields()
        } catch (error) {
          console.error('Error saving product:', error)
          swal({
            title: 'Eroare',
            text: 'A apărut o eroare la salvarea produsului.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      },
      async fetchGestiuni () {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
          const data = await response.json()

          if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
            this.gestiuniList = data.gestiuni
          } else {
            swal({
              title: 'Error!',
              text: 'Nu s-a primit un array valid de la server.',
              icon: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          swal({
            title: 'Error!',
            text: `Request failed: ${error.message}`,
            icon: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          console.error('Error fetching management data:', error)
        }
      },
      resetFields () {
        this.name = ''
        this.description = ''
        this.code = ''
      },
      onProductSelect (selectedProduct) {
        if (selectedProduct && selectedProduct.id === 'add') {
          this.addProductModal()
          return
        }

        if (selectedProduct && selectedProduct._id) {
          this.posId = selectedProduct._id
          this.productNameRecipe = selectedProduct.name || ''
          this.productTypeRecipe = selectedProduct.categorie || ''
          this.codeProductRecipe = selectedProduct.product_code || ''
          this.umRecipe = selectedProduct.um || ''
          this.isProductSelected = true
        } else {
          this.isProductSelected = false
        }
      },
      async handleDelete () {
        if (!this.id) {
          console.error('Missing product ID for deletion.')
          return
        }

        try {
          swal({
            title: 'Ești sigur că vrei să ștergi acest produs?',
            text: 'Această acțiune nu poate fi anulată!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Da, șterge-l!',
            cancelButtonText: 'Anulează'
          }).then(async (result) => {
            if (!result) return

            swal({
              type: 'warning',
              title: 'Ștergere...',
              text: 'Se șterge produsul. Așteaptă...',
              allowOutsideClick: false,
              showConfirmButton: false
            })

            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/remove`, {
              method: 'DELETE',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                type: 'product',
                id: this.id,
                posId: this.id,
                externalCompanyId: this.companyID
              })
            })

            const data = await response.json()

            if (!response.ok) {
              // Dacă e eroare 409, afișăm exact mesajul API-ului și **nu închidem alerta automat**
              if (response.status === 409 && data.error) {
                swal({
                  title: 'Eroare',
                  text: `${data.error}\nID: ${data.taptasty_ray_id || ''}`,
                  type: 'error',
                  showConfirmButton: true // alertă rămâne până utilizatorul dă OK
                })
                return
              } else {
                throw new Error(`HTTP error! Status: ${response.status}`)
              }
            }

            swal.close()

            swal({
              title: 'Succes',
              text: 'Produsul a fost șters cu succes.',
              type: 'success',
              timer: 2000,
              showConfirmButton: false
            })

            this.$bus.$emit('refresh')
            this.$bus.$emit('close-modal')
          })
        } catch (error) {
          swal.close()
          console.error('Error deleting product:', error)

          swal({
            title: 'Eroare',
            text: error.message || 'A apărut o eroare la ștergerea produsului.',
            type: 'error',
            showConfirmButton: true // rămâne până când utilizatorul dă OK
          })
        }
      },
      backButton () {
        // const vatNumberProduct = this.route.params.vatNumber
        // this.router.push({
        //   path: '/management/sidebar',
        //   query: { tab: 'reteta', vatNumber: vatNumberProduct }
        // })

        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      },
      async deleteRow (row) {
        const index = this.tableData.findIndex(item => item === row)

        if (index === -1) {
          console.error('Item not found in tableData')
          return
        }

        const removed = this.tableData.splice(index, 1)[0]

        try {
          await this.saveOrFetchRecipe()

          swal({
            title: 'Succes',
            text: 'Rețeta a fost ștearsă cu succes!',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })
        } catch (error) {
          // rollback dacă save eșuează
          this.tableData.splice(index, 0, removed)

          console.error('Error updating recipe:', error)

          swal({
            title: 'Eroare',
            text: 'A apărut o eroare la ștergerea rețetei.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      },
      addProductModal () {
        this.$modal.show('addProduct')
      },
      closeProduct () {
        this.$modal.hide('addProduct')
      },
      openAddProductModal (product = null) {
        if (product && product.posId) {
          // Mod editare
          this.isEditing = true
          this.editingProduct = product

          this.posId = product.posId || ''
          this.productNameRecipe = product.productNameRecipe || ''
          this.selectedCategory = product.productTypeRecipe || ''
          this.codeProductRecipe = product.codeProductRecipe || ''
          this.umRecipe = product.umRecipe || ''
          this.quantityRecipe = product.quantityRecipe || ''
          this.scazamantValue = product.scazamantValue || ''
          this.scazamantType = product.scazamantType || ''
          this.searchResults = [product]
        } else {
          this.isEditing = false
          this.editingProduct = null

          this.productNameRecipe = null
          this.searchResults = []
          this.codeProductRecipe = ''
          this.umRecipe = ''
          this.quantityRecipe = ''
          this.scazamantValue = 0
          this.posId = null
          this.selectedCategory = ''
          this.scazamantValue = ''
          this.scazamantType = ''
        }

        this.$modal.show('addProductModal')
      },
      closeModal () {
        this.productNameRecipe = null
        this.codeProductRecipe = ''
        this.umRecipe = ''
        this.quantityRecipe = ''

        this.$modal.hide('addProductModal')
      }
    }
  }
</script>

<style scoped>
.settings-top-bar {
  z-index: 9;
}

.v-select input[type=search],
.v-select input[type=search]:focus {
  min-height: 44px;
}

/* ACTION BUTTONS */
.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

button.btn.btn-info.btn-icon {
  border: 1px solid transparent;
  margin-right: 10px;
}

button.btn.btn-info.btn-icon:hover,
button.btn.btn-info.btn-icon:active {
  background-color: #E4F4FF;
  border-color: #0097FC;
  color: #0097FC;
}

/* FORMS */
.form-group {
  margin-bottom: 16px;
}

/* TEXT */
strong {
  color: #25396F;
  margin-right: 10px;
}

/* INFO BOX */
.info-text {
  width: max-content;
  margin-bottom: 20px;
  font-size: 13px;
  font-weight: 400;
  color: #000;
  background-color: #fff;
  padding: 7px 10px;
  border-radius: 9px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.1);
}

.info-text--bold {
  font-weight: 600;
}

/* CARD BASE */
.card-price {
  background: #fff;
  padding: 10px;
  border-radius: 10px;
  margin-bottom: 10px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
  border: 1px solid #edf2f7;
  height: 100%;
}

/* ARROW */
.arrow-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #674BD2;
  border-radius: 6px;
  color: #674BD2;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
}

.highlight-row {
  background-color: #fff3cd !important;
  transition: background-color 0.5s ease;
}

.arrow-box:hover {
  background-color: #674BD2;
  color: #fff;
}

/* DROPDOWN */
.custom-dropdown-menu {
  min-width: 140px;
}

/* LAYOUT */
.left-buttons {
  display: flex;
}

.right-button {
  margin-left: auto;
}

/* BUTTON GROUP */
.button-group {
  display: flex;
  justify-content: flex-end;
}

.button-group .btn {
  margin-right: 10px;
}

.button-group .btn:last-child {
  margin-right: 0;
}

/* LOADER */
.card-loader {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
  justify-content: center;
}

.spinner {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 4px solid #e6ebf5;
  border-top: 4px solid #25396F;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

/* EMPTY */
.empty-stock {
  text-align: center;
  color: #7C8DB5;
  padding: 50px 0;
}

/* STOCK CARD */
.stock-card {
  border-radius: 16px;
  background: #fff;
  padding: 18px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
  border: 1px solid #edf2f7;

  /* IMPORTANT */
  height: 100%;
  min-height: 420px; /* alegi tu valoarea */
  display: flex;
  flex-direction: column;
}

.stock-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.stock-title {
  margin: 0;
  font-weight: 700;
  color: #25396F;
  font-size: 18px;
}

.stock-subtitle {
  color: #7C8DB5;
}

.stock-badge {
  background: #eef3ff;
  color: #25396F;
  font-weight: 700;
  border-radius: 10px;
  padding: 6px 12px;
  font-size: 12px;
}

/* SUMMARY */
.summary-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}

.summary-box {
  background: #f8faff;
  border-radius: 12px;
  padding: 12px;
}

.summary-box small {
  display: block;
  color: #7C8DB5;
  margin-bottom: 4px;
}

.summary-box strong {
  color: #25396F;
  font-size: 16px;
}

/* PRODUCT INFO */
.product-info {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  gap: 10px;
}

.info-row span {
  color: #7C8DB5;
}

.info-row strong {
  color: #25396F;
  text-align: right;
}

/* TABLE */
.stock-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.stock-table th {
  background: #f7f9fc;
  color: #25396F;
  padding: 8px;
  font-weight: 700;
  text-align: left;
}

.stock-table td {
  padding: 8px;
  border-bottom: 1px solid #edf2f7;
}

.table-responsive {
  overflow-x: auto;
}

/* SELECT LOADER */
.v-select-wrapper {
  position: relative;
}
.small, small {
  font-size: 10px;
}
.v-select-loader {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: 3px solid #e0e0e0;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

/* ========== STILURI TABEL ISTORIC ========== */

.history-table-wrapper {
  max-height: 450px;
  overflow-y: auto;
  overflow-x: hidden;
}

.history-table {
  width: 100%;
  table-layout: fixed;
  font-size: 12px;
  margin-bottom: 0;
  border-collapse: collapse;
}

/* === HEADER === */
.history-table thead th {
  background: #f8f9fa;
  font-weight: 600;
  padding: 8px 6px;
  border-bottom: 2px solid #dee2e6;
  white-space: nowrap;
  position: sticky;
  top: 0;
  z-index: 2;
  font-size: 11px;
  text-transform: uppercase;
  color: #495057;
}

/* === LĂȚIMI FIXE COLOANE === */
.col-data      { width: 120px; }
.col-document  { width: auto; }
.col-intrare   { width: 85px; }
.col-iesire    { width: 85px; }
.col-stoc      { width: 85px; }
.col-pret      { width: 95px; }

/* === RÂNDURI ISTORIC === */
.history-row td {
  padding: 6px;
  vertical-align: middle;
  border-bottom: 1px solid #e9ecef;
  line-height: 1.4;
}

.history-row:hover td {
  background: #f8f9fa;
}

/* === INFO DOCUMENT - CLICKABLE === */
.doc-info {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  cursor: pointer;
}

.doc-info:hover .badge.clickable {
  opacity: 0.8;
  transform: scale(1.02);
}

.badge {
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 3px;
  font-weight: 600;
  display: inline-block;
  white-space: nowrap;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.badge.clickable {
  cursor: pointer;
}

.doc-number-black {
  color: #212529;
  font-size: 11px;
  font-weight: 500;
  white-space: nowrap;
}

/* === LABEL PRODUS FABRICAT === */
.produced-label {
  margin-top: 4px;
  display: inline-block;
  cursor: pointer;
}

.label-badge {
  display: inline-block;
  font-size: 10px;
  padding: 2px 8px;
  border-radius: 3px;
  background: #e3f2fd;
  color: #1565c0;
  font-weight: 600;
  border: 1px solid #bbdefb;
  transition: background 0.15s ease;
}

.produced-label:hover .label-badge {
  background: #bbdefb;
}

.badge-success { background: #d4edda; color: #155724; }
.badge-danger  { background: #f8d7da; color: #721c24; }
.badge-info    { background: #d1ecf1; color: #0c5460; }
.badge-warning { background: #fff3cd; color: #856404; }
.badge-primary { background: #cce5ff; color: #004085; }
.badge-default { background: #e2e3e5; color: #383d41; }

/* === CULORI === */
.text-success { color: #28a745 !important; }
.text-danger  { color: #dc3545 !important; }
.text-muted   { color: #6c757d !important; }

/* === ALINIERE === */
.text-right {
  text-align: right !important;
}

/* === SCROLLBAR === */
.history-table-wrapper::-webkit-scrollbar {
  width: 6px;
}

.history-table-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.history-table-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

/* === RESPONSIVE === */
@media (max-width: 1200px) {
  .col-data    { width: 100px; }
  .col-intrare { width: 75px; }
  .col-iesire  { width: 75px; }
  .col-stoc    { width: 75px; }
  .col-pret    { width: 85px; }
}
/* Aliniere la stânga pentru carduri cu spațiere */
.stock-cards-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  margin-left: -10px;
  margin-right: -10px;
}

.stock-card-col {
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 20px;
}

.stock-cards-row::before,
.stock-cards-row::after {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Nomenclator/NomenclatorProductsEdit.vue